var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapitulo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.6,19.9c-0.1,0-0.2,0-0.3-0.1c-3.3-2.1-7.5,0-7.5,0c-0.2,0.1-0.4,0.1-0.5,0c-4.1-2-7.6,0-7.6,0 c-0.2,0.1-0.4,0.1-0.6,0c-0.2-0.1-0.3-0.3-0.3-0.5V7.9c0-0.2,0.1-0.4,0.3-0.5c5.4-2.7,8.7,0,8.8,0.1C13.2,7.6,13.2,8,13,8.3 c-0.2,0.3-0.6,0.3-0.9,0.1C12,8.3,9.5,6.2,5,8.3v10c1.4-0.5,4.3-1.2,7.6,0.3c1-0.4,4.3-1.7,7.5-0.3V8.1c0-0.3,0.3-0.6,0.6-0.6 c0.3,0,0.6,0.3,0.6,0.6v11.2c0,0.2-0.1,0.4-0.3,0.5C20.8,19.9,20.7,19.9,20.6,19.9 M14.2,16.6c0.1,0,0.3-0.1,0.4-0.2l3.8-3.5 c0.1-0.1,0.2-0.3,0.2-0.5V4.4c0-0.2-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.1-0.7,0.1l-3.8,3.5c-0.1,0.1-0.2,0.3-0.2,0.5V16 c0,0.2,0.1,0.5,0.4,0.6C14.1,16.6,14.2,16.6,14.2,16.6 M17.5,5.8v6.4l-2.6,2.4V8.2L17.5,5.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitulo);
export default __webpack_public_path__ + "static/media/capitulo.8312b297e548114bdde9288653024d8c.svg";
export { ForwardRef as ReactComponent };